import React from "react";
import Svg, { Path, G, Defs, ClipPath } from "react-native-svg";

function Address(props) {
  return (
    <Svg
      width="128"
      height="96"
      viewBox="0 0 128 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M85.8715 81.8164H4.09012C1.8306 81.8164 0 83.6478 0 85.9103C0 88.169 1.8306 90.0004 4.09012 90.0004H85.8696C88.1291 90.0004 89.9597 88.169 89.9597 85.9103C89.9578 83.6478 88.1272 81.8164 85.8715 81.8164Z"
        fill="#E5E5E5"
      />
      <Path
        d="M9.2034 71.174C6.94388 71.174 5.11328 73.0055 5.11328 75.266C5.11328 77.5266 6.94388 79.3599 9.2034 79.3599H80.7614C83.0209 79.3599 84.8515 77.5266 84.8515 75.266C84.8515 73.0055 83.0209 71.174 80.7614 71.174H79.7408V34.3538H80.7614C81.8931 34.3538 82.8046 33.4381 82.8046 32.3097C82.8046 31.1813 81.8892 30.2656 80.7614 30.2656H9.2034C8.07364 30.2656 7.16026 31.1813 7.16026 32.3097C7.16026 33.4381 8.07556 34.3538 9.2034 34.3538H10.2259V71.1721H9.2034V71.174ZM71.5605 34.3538V71.1721H59.294V34.3538H71.5605ZM51.1138 34.3538V71.1721H38.8472V34.3538H51.1138ZM18.4024 34.3538H30.6689V71.1721H18.4024V34.3538Z"
        fill="#E5E5E5"
      />
      <Path
        d="M4.0902 26.5893H85.8697C85.8831 26.5893 85.8984 26.5893 85.9099 26.5893C88.1713 26.5893 90 24.7579 90 22.4973C90 20.7004 88.8434 19.1774 87.2369 18.6256L46.6612 0.359199C45.5946 -0.119733 44.3748 -0.119733 43.3064 0.359199L2.41279 18.7674C0.653042 19.5605 -0.313958 21.4724 0.0919905 23.3575C0.496024 25.2426 2.16194 26.5893 4.0902 26.5893Z"
        fill="#E5E5E5"
      />
      <Path
        d="M106.889 85.3184V90.01H125.655V85.3184H109.234H106.889Z"
        fill="#EBC62E"
      />
      <Path
        d="M83.7588 85.6738V89.7702H102.602V85.6738H84.9365H83.7588Z"
        fill="#F9D74E"
      />
      <Path
        d="M78.8432 85.6738H61.1777H60V89.7702H78.8432V85.6738Z"
        fill="#EBC62E"
      />
      <Path
        d="M79.6625 85.6754V80.7598H78.4848H60.8193V85.6754H78.4848H79.6625Z"
        fill="#F9D74E"
      />
      <Path
        d="M78.8432 75.8438H60V80.7594H61.1777H78.8432V75.8438Z"
        fill="#EBC62E"
      />
      <Path
        d="M84.5781 85.6754H102.244H103.421V80.7598H102.244H84.5781V85.6754Z"
        fill="#EBC62E"
      />
      <Path
        d="M83.7588 75.8438V80.7594H84.9365H102.602V75.8438H84.9365H83.7588Z"
        fill="#F9D74E"
      />
      <Path
        d="M84.5781 75.8434H102.244H103.421V70.9277H102.244H84.5781V75.8434Z"
        fill="#EBC62E"
      />
      <Path
        d="M83.4287 66.5527V71.2444H84.6016H102.195V66.5527H83.4287Z"
        fill="#F9D74E"
      />
      <Path
        d="M109.232 85.3186H125.653H127.999V80.627H125.653H109.232V85.3186Z"
        fill="#F9D74E"
      />
      <Path
        d="M106.698 75.8438V80.7594H109.054H125.541V75.8438H109.054H106.698Z"
        fill="#EBC62E"
      />
      <Path
        d="M109.156 75.8434H125.644H127.999V70.9277H126.822H109.156V75.8434Z"
        fill="#F9D74E"
      />
      <Path
        d="M108.337 70.9284H109.515H127.18V66.832H126.002H108.337V70.9284Z"
        fill="#EBC62E"
      />
      <Path
        d="M106.698 61.916V66.8316H107.876H125.541V61.916H109.054H106.698Z"
        fill="#F9D74E"
      />
      <Path
        d="M109.156 61.9156H125.644H127.999V57H109.156V61.9156Z"
        fill="#EBC62E"
      />
      <Path
        d="M106.911 35C106.911 35 106.911 39.9107 111.821 39.9107C111.821 39.9107 106.911 39.9107 106.911 44.8214C106.911 44.8214 106.911 39.9107 102 39.9107C102 39.9107 106.911 39.9107 106.911 35Z"
        fill="#E40046"
      />
      <Path
        d="M64.9107 58C64.9107 58 64.9107 62.9107 69.8214 62.9107C69.8214 62.9107 64.9107 62.9107 64.9107 67.8214C64.9107 67.8214 64.9107 62.9107 60 62.9107C60 62.9107 64.9107 62.9107 64.9107 58Z"
        fill="#E40046"
      />
      <Path
        d="M44.6863 94.8863C54.7379 94.8863 62.8863 86.7379 62.8863 76.6863C62.8863 66.6347 54.7379 58.4863 44.6863 58.4863C34.6347 58.4863 26.4863 66.6347 26.4863 76.6863C26.4863 86.7379 34.6347 94.8863 44.6863 94.8863Z"
        fill="#FFD422"
      />
      <Path
        d="M56.9828 75.4218L59.7511 75.1781C59.664 74.1682 59.4725 73.1584 59.1939 72.166L56.5127 72.9495C56.7739 73.7678 56.9131 74.5861 56.9828 75.4218Z"
        fill="#FFA733"
      />
      <Path
        d="M54.1984 64.6459C53.4149 64.0017 52.5617 63.4271 51.6564 62.957L50.3506 65.4119C51.0992 65.795 51.7957 66.2651 52.4399 66.8048L54.1984 64.6459Z"
        fill="#FFA733"
      />
      <Path
        d="M58.046 69.3447C57.5759 68.4393 57.0014 67.5862 56.3572 66.8027L54.1982 68.5612C54.738 69.2054 55.1907 69.9018 55.5911 70.6505L58.046 69.3447Z"
        fill="#FFA733"
      />
      <Path
        d="M43.0707 64.0535L42.7573 61.2852C41.7475 61.407 40.7377 61.616 39.7627 61.9294L40.6158 64.5758C41.4167 64.3146 42.235 64.1405 43.0707 64.0535Z"
        fill="#FFA733"
      />
      <Path
        d="M48.8163 61.7857C47.8414 61.5071 46.8315 61.3156 45.8043 61.2285L45.5605 63.9968C46.3963 64.0665 47.2146 64.2232 48.0155 64.4495L48.8163 61.7857Z"
        fill="#FFA733"
      />
      <Path
        d="M41.0352 91.4211C42.0276 91.6475 43.0548 91.7868 44.0646 91.8042L44.1343 89.0185C43.2985 89.0011 42.4628 88.8792 41.6445 88.7051L41.0352 91.4211Z"
        fill="#FFA733"
      />
      <Path
        d="M35.4971 88.8943C36.3328 89.5036 37.2033 90.0085 38.1435 90.4438L39.31 87.9018C38.5439 87.5536 37.8301 87.1358 37.1511 86.6309L35.4971 88.8943Z"
        fill="#FFA733"
      />
      <Path
        d="M54.8408 83.5686L57.139 85.1355C57.7136 84.2998 58.2011 83.3945 58.6015 82.4543L56.0422 81.3574C55.7288 82.1409 55.3283 82.8896 54.8408 83.5686Z"
        fill="#FFA733"
      />
      <Path
        d="M46.6426 88.8628L47.1127 91.6137C48.1225 91.4396 49.1149 91.161 50.0551 90.7954L49.0453 88.2012C48.2618 88.4972 47.4609 88.7061 46.6426 88.8628Z"
        fill="#FFA733"
      />
      <Path
        d="M51.2715 87.0494L52.7862 89.3824C53.6393 88.8253 54.4402 88.1985 55.1715 87.4847L53.2215 85.4824C52.6295 86.0744 51.9679 86.5967 51.2715 87.0494Z"
        fill="#FFA733"
      />
      <Path
        d="M56.79 79.7729L59.5235 80.3301C59.7324 79.3203 59.8195 78.3104 59.8195 77.2832H57.0338C57.0338 78.1189 56.9467 78.9546 56.79 79.7729Z"
        fill="#FFA733"
      />
      <Path
        d="M34.5745 68.8371L32.3633 67.1309C31.7366 67.9318 31.1968 68.8023 30.7441 69.7251L33.2513 70.9612C33.6169 70.2126 34.0522 69.4987 34.5745 68.8371Z"
        fill="#FFA733"
      />
      <Path
        d="M35.2703 84.9768C34.6957 84.3675 34.2082 83.6884 33.773 82.9746L31.3877 84.4197C31.91 85.2902 32.5368 86.1085 33.2332 86.8572L35.2703 84.9768Z"
        fill="#FFA733"
      />
      <Path
        d="M32.0849 78.2754L29.334 78.6758C29.4733 79.6857 29.717 80.6781 30.0652 81.6531L32.6943 80.7129C32.4157 79.9294 32.2068 79.1111 32.0849 78.2754Z"
        fill="#FFA733"
      />
      <Path
        d="M32.366 73.3134L29.6674 72.5996C29.4062 73.592 29.2495 74.6018 29.1973 75.6291L31.983 75.7858C32.0352 74.9501 32.1571 74.1143 32.366 73.3134Z"
        fill="#FFA733"
      />
      <Path
        d="M38.3349 65.5822L36.9595 63.1621C36.0715 63.667 35.2358 64.259 34.4697 64.9206L36.2804 67.0273C36.9246 66.4701 37.6037 66.0001 38.3349 65.5822Z"
        fill="#FFA733"
      />
      <Path
        d="M50.5919 69.4152H47.79C48.2012 70.058 48.4693 70.8036 48.5944 71.6518H51.2891L50.5785 74.3036H48.581C48.3754 75.6339 47.8437 76.692 46.9857 77.4777C46.1277 78.2634 44.8943 78.8125 43.2855 79.125L49.1441 86.0625V86.25H44.7066L38.218 78.6562L38.2046 76.2991H41.3818C43.0353 76.2991 44.072 75.6339 44.4921 74.3036H37.8828L38.5799 71.6518H44.4117C43.9737 70.5714 43.0129 70.0223 41.5293 70.0045H37.8828L38.6738 66.75H51.2891L50.5919 69.4152Z"
        fill="#FFA733"
      />
      <Path
        d="M44.5 96C55.2772 96 64 87.2772 64 76.5C64 65.7228 55.2772 57 44.5 57C33.7228 57 25 65.7228 25 76.5C25.0174 87.2598 33.7402 95.9826 44.5 96ZM44.5 59.7857C53.7277 59.7857 61.2143 67.2723 61.2143 76.5C61.2143 85.7277 53.7277 93.2143 44.5 93.2143C35.2723 93.2143 27.7857 85.7277 27.7857 76.5C27.8031 67.2723 35.2723 59.8031 44.5 59.7857Z"
        fill="#FFA733"
      />
    </Svg>
  );
}

export default Address;
